// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"procedure-module__wrapper___iQIHc","container":"procedure-module__container___2Ob8t","number":"procedure-module__number___34zqV"};